import React from 'react'
import { AppBar, styled } from '@mui/material'
import MobileHeader from './MobileHeader'
import Header from './Header'
import { useIsSmallScreen } from '../../core/hooks'

const StyledAppBar = styled(AppBar)(({ bgColor }) => ({
    backgroundColor: bgColor,
}))

const GenericHeader = (props) => {
    const isSmallScreen = useIsSmallScreen()
    const { bgColor } = props

    return (
        <StyledAppBar bgColor={bgColor}>
            {isSmallScreen ? (
                <MobileHeader {...props} />
            ) : (
                <Header {...props} />
            )}
        </StyledAppBar>
    )
}

export default GenericHeader
